import { Plus } from 'lucide-react'

import { HeaderConfigBar } from '@fortem-monorepo/react-spa'
import { Button, SearchSelect, TabsList, TabsTrigger } from '@fortem-monorepo/react-ui'

import { CanAccess } from '@/components/CanAccess'
import { PERMISSIONS } from '@/constants/permissions'
import { useMarketSummaryActions } from '@/pages/instruments/market-summary/market-summary-actions'
import { DISPLAY_TABS, useMarketSummaryContext } from '@/pages/instruments/market-summary/market-summary-context'

export interface MarketSummaryDisplayControlsProps {}

export const MarketSummaryDisplayControls: React.FC<MarketSummaryDisplayControlsProps> = () => {
  const { viewsQuery, selectView, view, displayTab, metricsQuery, displayInstrumentsQuery, instrumentsQuery } =
    useMarketSummaryContext()
  const { addMetric, addInstrumentToDisplay, actionState } = useMarketSummaryActions()

  const viewOptions = (viewsQuery.data ?? []).map((view) => {
    return {
      label: view.display_name,
      value: view.display_id.toString(),
    }
  })

  return (
    <HeaderConfigBar>
      <div className="flex flex-wrap items-center gap-4">
        <SearchSelect
          size="sm"
          value={view?.display_id?.toString()}
          placeholder={'Choose a view...'}
          disabled={!viewsQuery.data || viewsQuery.isFetching}
          options={viewOptions}
          setValue={(val) => {
            const view = viewsQuery.data?.find((view) => view.display_id === parseInt(val))
            if (view) {
              selectView(view)
            }
          }}
          loading={viewsQuery.isFetching}
        />
        <TabsList>
          <TabsTrigger value={DISPLAY_TABS.REPORT}>Report</TabsTrigger>
          <TabsTrigger value={DISPLAY_TABS.INSTRUMENTS}>Instruments</TabsTrigger>
          <TabsTrigger value={DISPLAY_TABS.METRICS}>Values</TabsTrigger>
        </TabsList>
        <CanAccess permissions={[PERMISSIONS.WRITE_MARKET_SUMMARY]}>
          {displayTab === DISPLAY_TABS.INSTRUMENTS && (
            <Button
              size="sm"
              variant={'outline'}
              onClick={() => {
                if (view) addInstrumentToDisplay({ display_id: view.display_id })
              }}
              disabled={
                !view ||
                !displayInstrumentsQuery.data ||
                displayInstrumentsQuery.isFetching ||
                !instrumentsQuery.data ||
                actionState !== null
              }
            >
              Add new instrument <Plus />
            </Button>
          )}
          {displayTab === DISPLAY_TABS.METRICS && (
            <Button
              size="sm"
              variant={'outline'}
              onClick={() => addMetric({ display_id: view?.display_id! })}
              disabled={!metricsQuery.data || metricsQuery.isFetching}
            >
              Add new metric <Plus />
            </Button>
          )}
        </CanAccess>
      </div>
    </HeaderConfigBar>
  )
}
